export const locationsMock = [
  //? Main location
  {
    id: 1,
    name: 'General Hospital HQ',
    description: 'General Hospital HQ',
    //TODO - Update coordinates
    latitude: -76.024952,
    longitude: 43.16615,
    parentId: null,
    parentName: null,
    carts: 0,
    userGroups: 0,
  },

  //* Child locations
  {
    id: 2,
    name: 'Manhattan',
    description: 'Manhattan',
    latitude: null,
    longitude: null,
    parentId: 1,
    parentName: 'General Hospital HQ',
    carts: 0,
    userGroups: 0,
  },
  {
    id: 3,
    name: 'Brooklyn',
    description: 'Brooklyn',
    latitude: null,
    longitude: null,
    parentId: 1,
    parentName: 'General Hospital HQ',
    carts: 0,
    userGroups: 0,
  },
  {
    id: 4,
    name: 'Bronx',
    description: 'Bronx',
    latitude: null,
    longitude: null,
    parentId: 1,
    parentName: 'General Hospital HQ',
    carts: 0,
    userGroups: 0,
  },

  //* Manhattan buildings
  {
    id: 5,
    name: ' Building A',
    description: ' Building A',
    latitude: null,
    longitude: null,
    parentId: 2,
    parentName: 'Manhattan',
    carts: 0,
    userGroups: 0,
  },
  {
    id: 6,
    name: 'Building B',
    description: 'Building B',
    latitude: null,
    longitude: null,
    parentId: 2,
    parentName: 'Manhattan',
    carts: 0,
    userGroups: 0,
  },
  {
    id: 7,
    name: 'Building C',
    description: 'Building C',
    latitude: null,
    longitude: null,
    parentId: 2,
    parentName: 'Manhattan',
    carts: 0,
    userGroups: 0,
  },

  //* Brooklyn buildings
  {
    id: 8,
    name: 'Building A',
    description: 'Building A',
    latitude: null,
    longitude: null,
    parentId: 3,
    parentName: 'Brooklyn',
    carts: 0,
    userGroups: 0,
  },
  {
    id: 9,
    name: 'Building B',
    description: 'Building B',
    latitude: null,
    longitude: null,
    parentId: 3,
    parentName: 'Brooklyn',
    carts: 0,
    userGroups: 0,
  },
  {
    id: 10,
    name: 'Building C',
    description: 'Building C',
    latitude: null,
    longitude: null,
    parentId: 3,
    parentName: 'Brooklyn',
    carts: 0,
    userGroups: 0,
  },

  //* Bronx buildings
  {
    id: 11,
    name: 'Building A',
    description: 'Building A',
    latitude: null,
    longitude: null,
    parentId: 4,
    parentName: 'Bronx',
    carts: 0,
    userGroups: 0,
  },
  {
    id: 12,
    name: 'Building B',
    description: 'Building B',
    latitude: null,
    longitude: null,
    parentId: 4,
    parentName: 'Bronx',
    carts: 0,
    userGroups: 0,
  },
  {
    id: 13,
    name: 'Building C',
    description: 'Building C',
    latitude: null,
    longitude: null,
    parentId: 4,
    parentName: 'Bronx',
    carts: 0,
    userGroups: 0,
  },
];
